// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__OFEuN","left":"Virtual_left__ZEyHJ","wrapper":"Virtual_wrapper__VKfUj"};